import * as React from "react";

import { EnquiryContext } from "./context/EnquiryState";

const initialOptions = [
	{
		label: "General enquiry",
		id: 1,
		steps: 1,
	},
	//{
	//	label: "Request a tour",
	//	id: 2,
	//	steps: 3,
	//},
	//{
	//	label: "Waitlist",
	//	id: 3,
	//	steps: 4,
	//},
	{
		label: "Live Tour Booking",
		id: 4,
		steps: 3
	},
	{
		label: "Live Tour Booking",
		id: 5,
		steps: 1,
	},
	//{
	//	label: "Waitlist",
	//	id: 6,
	//	steps: 1,
	//},
]

export const HomeFormComponent = () => {

	const {
		state,
		dispatch,
		WaitlistRedirect,
		TrackAnalyticsEvent
	} = React.useContext(EnquiryContext)

	React.useEffect(() => {
		dispatch({ type: "SET_FORM_COMPONENT", payload: "home" })

		dispatch({ type: 'RESET_OPTION'})

		TrackAnalyticsEvent("start")
	}, [])

	return (
		<React.Fragment>
			<div className="mb-6 text-skin-grey text-base-15" style={{ lineHeight: "18px" }}>
				Welcome to our enquiry form, begin by selecting an option below, this form will take you less than 3 minutes.
			</div>
			<div className="mb-6 font-semibold text-xl">
				What would you like to enquire about?
			</div>
			<div className="text-xs mb-6">
				PLEASE SELECT ONE
			</div>
			<div className="flex flex-wrap gap-4 items-center">
				{initialOptions.map(option => {
					
					if (option.id == 1 && state.model?.enquiryCentreDetailsList[0].isGeneralEnquiryAvailable) {
						return <button
							onClick={() => dispatch({ type: 'SELECT_OPTION', payload: option })}
							data-event-context="type=selectGeneralEnquiry"
							className="button bg-skin-cacti font-semibold text-black">{option.label}</button>
					}

					// Std tour booking
					if (option.id == 4 && state.model?.enquiryCentreDetailsList[0].isLiveTourBookingAvailable) {
						return <button
							onClick={() => dispatch({ type: 'SELECT_OPTION', payload: option })}
							data-event-context="type=selectBookATour"
							className="button bg-skin-cacti font-semibold text-black">{option.label}</button>
					}

					// Embedded tour booking
					if (option.id == 5 && state.model?.enquiryCentreDetailsList[0].hasEmbeddedRequestATour) {
						return <button
							onClick={() => dispatch({ type: 'SELECT_OPTION', payload: option })}
							data-event-context="type=selectEmbeddedBookATour"
							className="button bg-skin-cacti font-semibold text-black">{option.label}</button>
					}

					// Std Waitlist
					if (option.id == 3 && state.model?.enquiryCentreDetailsList[0].isWaitlistAvailable) {
						// Waitlist redirects to another page
						return <button
							onClick={() => WaitlistRedirect()}
							data-event-context="type=selectWaitlist"
							id="enquiry-waitlist-cta"
							className="button bg-skin-cacti font-semibold text-black">{option.label}</button>
					}
					
					// Embedded Waitlist
					if (option.id == 6 && state.model?.enquiryCentreDetailsList[0].hasEmbeddedWaitlist) {
						return <button
							onClick={() => dispatch({ type: 'SELECT_OPTION', payload: option })}
							data-event-context="type=selectEmbeddedWaitlist"
							className="button bg-skin-cacti font-semibold text-black">{option.label}</button>
					}
					
				})}
			</div>
		</React.Fragment>
	);
}